import React, {useState} from 'react';
import {Grid} from "@mui/material";
import Alert from '@mui/material/Alert';
import {useTranslation} from "react-i18next";
import Table from "./table/Table";
import Toolbar from "../../typography/Toolbar";
import AddIcon from "@mui/icons-material/Add";
import Button from "../../inputs/Button";
import AddDialog from "./AddDialog";

const OAuth = () => {
    const {t} = useTranslation();
    const [addDialogOpened, setAddDialogOpened] = useState(false);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Toolbar title={t('profile_oauth')} disableGutters={true}>
                    <Button endIcon={<AddIcon/>} variant='contained' color='primary'
                            onClick={e => setAddDialogOpened(true)}>
                        {t('add_btn')}
                    </Button>
                </Toolbar>
            </Grid>
            <Grid item xs={12}>
                <Alert severity='info'>
                    {t('profile_oauth_desc')}
                </Alert>
            </Grid>
            <Grid item xs={12}>
                <Table/>
            </Grid>
            <AddDialog open={addDialogOpened} setOpen={setAddDialogOpened}/>
        </Grid>
    );
};

export default OAuth;